import React from 'react';

import { ReportInspectedProductsByMisstatementView } from './ReportInspectedProductsByMisstatementView';

export const ReportInspectedProductsByMisstatementIIIView: React.FC = () => {
  return <ReportInspectedProductsByMisstatementView group="III" />;
};
